import { getEntityTerminologyStatic } from '@/lib/terminology/static-terminology';

interface EntityTermForms {
  singular: string;
  plural: string;
  Singular: string;
  Plural: string;
}

/**
 * Replace the literal words "entity"/"entities" in display text with the
 * organization's configured terminology, preserving case. Stored keys and
 * identifiers must never pass through this — display strings only.
 */
export function rewriteEntityTerms(text: string, t: EntityTermForms = getEntityTerminologyStatic()): string {
  if (!text || !/entit/i.test(text)) return text;
  return text
    .replace(/\bENTITIES\b/g, t.plural.toUpperCase())
    .replace(/\bENTITY\b/g, t.singular.toUpperCase())
    .replace(/\bEntities\b/g, t.Plural)
    .replace(/\bEntity\b/g, t.Singular)
    .replace(/\bentities\b/g, t.plural)
    .replace(/\bentity\b/g, t.singular);
}

interface DisplayableRole {
  name?: string | null;
  description?: string | null;
  isSystem?: boolean;
}

/**
 * Display name for a record-permission role. System roles are seeded with
 * "Entity …" wording, which we rewrite to the org's terminology at display
 * time only — the stored role name/key is never changed. Custom
 * (user-authored) role names are shown verbatim.
 */
export function roleDisplayName(role: DisplayableRole, t?: EntityTermForms): string {
  const name = role.name ?? '';
  return role.isSystem ? rewriteEntityTerms(name, t) : name;
}

export function roleDisplayDescription(role: DisplayableRole, t?: EntityTermForms): string {
  const description = role.description ?? '';
  return role.isSystem ? rewriteEntityTerms(description, t) : description;
}
